import {
  Button,
  Flex,
  FlexProps,
  Icon,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import { MlsListingMlsFragment } from '@client/graphql/__generated__/types';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { ListingDisclaimer } from '../../pages/Storefront/ListingDisclaimer';

interface MlsDisclaimersProps extends FlexProps {
  disclaimers: MlsListingMlsFragment[];
}

export const MlsDisclaimers = ({
  disclaimers,
  ...props
}: MlsDisclaimersProps) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Flex
      alignItems="flex-start"
      direction="column"
      px={6}
      py={2}
      transition="gap 0.3s ease-in-out"
      width="100%"
      {...props}
    >
      <Button
        color="gray.500"
        rightIcon={
          <Icon as={isOpen ? ChevronUpIcon : ChevronDownIcon} boxSize="16px" />
        }
        size="xs"
        variant="link"
        onClick={onToggle}
      >
        Disclaimers
      </Button>
      <VStack
        height="100%"
        maxH={isOpen ? '50vh' : 0}
        mt={isOpen ? 2 : 0}
        overflowY="auto"
        spacing={4}
        transition="max-height 0.3s ease-in-out, margin-top 0.3s ease-in-out"
      >
        {disclaimers.map((mls) => (
          <ListingDisclaimer key={mls.originatingSystemName} mls={mls} />
        ))}
      </VStack>
    </Flex>
  );
};
